import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, tap } from 'rxjs';
import { ConfigService } from '../config.service';
import { ProfilesCommunity } from './types/partnerships';

@Injectable({
  providedIn: 'root',
})
export class ProfilesCommunityService {
  private _communityUpdatedSubject = new Subject<ProfilesCommunity>();
  communityUpdated$ = this._communityUpdatedSubject.asObservable();

  private _profilesCommunitySubject = new Subject<ProfilesCommunity[]>();
  profilesCommunity$ = this._profilesCommunitySubject.asObservable();

  constructor(private http: HttpClient, private config: ConfigService) {}

  getAllProfilesCommunity(): Observable<ProfilesCommunity[]> {
    return this.http.get<ProfilesCommunity[]>(`${this.config.dataApiUrl}/profiles-community`);
  }

  getProfilesCommunity(): Observable<ProfilesCommunity[]> {
    return this.getAllProfilesCommunity().pipe(
      tap((list) => this._profilesCommunitySubject.next(list))
    );
  }

  getProfilesCommunityById(id: string): Observable<ProfilesCommunity> {
    return this.http.get<ProfilesCommunity>(`${this.config.dataApiUrl}/profiles-community/${id}`);
  }

  updateProfilesCommunity(id: string, community: Partial<ProfilesCommunity>): Observable<ProfilesCommunity> {
    return this.http
      .put<ProfilesCommunity>(`${this.config.dataApiUrl}/profiles-community/${id}`, community)
      .pipe(
        tap((updated) => this._communityUpdatedSubject.next(updated))
      );
  }

  updateProfilesCommunityPartial(
    id: string,
    patch: Partial<ProfilesCommunity>,
  ): Observable<ProfilesCommunity> {
    return this.http
      .put<ProfilesCommunity>(
        `${this.config.dataApiUrl}/profiles-community/${id}`,
        patch,
      )
      .pipe(tap((updated) => this._communityUpdatedSubject.next(updated)));
  }
}

